import cookie from './cookie';
import consoleLog from './log';
import getClientType from './clientType';
import Env from './env';
import getTranslation from './getTranslation';
import removeTag from './removeTag';
import getUrlParam from './getUrlParam';
import windvane from './windvane';
import request from './request';
import Uploader from './upload';
import getAnonymousUserId from './get-anonymous-user-id';
import quickAction from './quick-action';

export {
  cookie,
  consoleLog,
  getClientType,
  getTranslation,
  Env,
  removeTag,
  getUrlParam,
  windvane,
  request,
  Uploader,
  getAnonymousUserId,
  quickAction,
};



// WEBPACK FOOTER //
// ./src/utils/index.js